import { createAction } from '@reduxjs/toolkit'
import type { LoaderType } from '@store/loaders/types'

export const LoaderActions = {
  set: createAction<LoaderType>('LOADERS_SET'),
  unset: createAction<LoaderType>('LOADERS_UNSET'),
}
